import { useState, useRef, useCallback } from 'react';
import ddt from '@wix/da-ddt';
import { ADDITIONAL_MEDIA_ID_PREFIX } from '../constants';
import { hasWindow } from '../../utils/browser';
const logger = ddt.createLogger('multifile');
/** A useState whose setter is wrapped to have the side-effect of updating the current url
 *  when the viewed image is changed, adding a hash fragment/deep link to that image */ export function useMultiArtCurrentImageTracking(mainImage, additionalMedia) {
    const [currentlyViewedImageSource, originalSetter] = useState(mainImage);
    const initialRender = useRef(true);
    const setCurrentlyViewedImageSource = useCallback((source)=>{
        const indexIntoImages = [
            mainImage,
            ...additionalMedia
        ].findIndex((s)=>s === source);
        var _source_title;
        logger.log('useMultiArtCurrentImageTracking, source:', (_source_title = source === null || source === void 0 ? void 0 : source['title']) !== null && _source_title !== void 0 ? _source_title : source === null || source === void 0 ? void 0 : source['filename'], 'index:', indexIntoImages);
        if (indexIntoImages >= 0) {
            const returned = originalSetter(source);
            // don't do this on the initial render or we'll overwrite a deeplink -into- the deviation
            // with the mainImage in the useState above
            if (!initialRender.current) {
                updateUrlWithDeepLink(indexIntoImages);
            } else {
                initialRender.current = false;
            }
            return returned;
        }
    }, [
        mainImage,
        additionalMedia,
        originalSetter
    ]);
    return [
        currentlyViewedImageSource,
        setCurrentlyViewedImageSource
    ];
}
function updateUrlWithDeepLink(index) {
    if (!hasWindow()) {
        return;
    }
    logger.log('useMultiArtCurrentImageTracking, index:', index);
    const newUrl = new URL(window.location.href);
    newUrl.hash = `${ADDITIONAL_MEDIA_ID_PREFIX}${index + 1}`;
    history.replaceState(null, '', newUrl);
}

//# sourceMappingURL=useMultiArtCurrentImageTracking.js.map